import { render } from "./SuccessTips.vue?vue&type=template&id=6a3b5c4e"
import script from "./SuccessTips.vue?vue&type=script&lang=js"
export * from "./SuccessTips.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__